import { useTranslation } from "react-i18next";
import { Users } from "lucide-react";

export const TargetAudience = () => {
  const { t } = useTranslation();
  const groups = t('targetAudience.groups', { returnObjects: true });

  return (
    <section 
      id="target-audience" 
      className="py-12 md:py-16 bg-white"
      data-testid="target-audience-section"
    >
      <div className="max-w-3xl mx-auto px-6">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 bg-[#1B4D3E]/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Users className="w-5 h-5 text-[#1B4D3E]" />
          </div>
          <div>
            <h2 
              className="text-lg md:text-xl font-semibold text-[#1B4D3E] mb-3"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              {t('targetAudience.headline')}
            </h2>
            <p className="text-stone-600 mb-4 leading-relaxed">
              {t('targetAudience.intro')}
            </p>
            <ul className="space-y-2">
              {groups.map((group, index) => (
                <li 
                  key={index}
                  className="flex items-start gap-2 text-stone-600 text-sm"
                  data-testid={`target-group-${index}`}
                >
                  <span className="w-1.5 h-1.5 bg-[#1B4D3E] rounded-full mt-2 flex-shrink-0" />
                  {group}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
